import { createFileRoute } from '@tanstack/react-router';
import { CampaignJourneyMetricsRouteView } from '@/pages/workspaces/automations/[campaignId]/metrics/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/journey_metrics',
)({
  component: CampaignJourneyMetricsRouteView,
});
